import { InternalPayItemConnectionClassTypeItem } from './InternalPayItemConnectionClassTypeItem'
import { CIMSModule } from '../../CIMSModule'

export const CAS = new InternalPayItemConnectionClassTypeItem({
  id: '3a42d318-b926-4140-94da-be3a662c8a49',
  module: CIMSModule.CAS,
  classType: 'ConstructionAdminSubmittal',
})
export const FDC = new InternalPayItemConnectionClassTypeItem({
  id: '0def659b-68fe-4367-980d-a386da14ccb7',
  module: CIMSModule.FDC,
  classType: 'FieldDesignChange',
})
export const CTS = new InternalPayItemConnectionClassTypeItem({
  id: 'c32ca42d-e82d-4cca-94f3-cfd1fcfacb37',
  module: CIMSModule.Concrete,
  classType: 'ConcreteTestSet',
})
export const DS = new InternalPayItemConnectionClassTypeItem({
  id: '8d1fac90-dd33-4491-bc21-e4e38498c3b7',
  module: CIMSModule.DS,
  classType: 'DesignSubmittal',
})
export const Issue = new InternalPayItemConnectionClassTypeItem({
  id: 'd4e5795f-a5ff-49fc-875f-ad3063bf457f',
  module: CIMSModule.Issues,
  classType: 'Issue',
})
export const EJ = new InternalPayItemConnectionClassTypeItem({
  id: '0aa7a7c7-0824-473f-9540-0b46c9f6a63e',
  module: CIMSModule.EJ,
  classType: 'EngineeringJudgement',
})
